import { render, staticRenderFns } from "./actorCard.vue?vue&type=template&id=49517c32&scoped=true"
import script from "./actorCard.vue?vue&type=script&lang=js"
export * from "./actorCard.vue?vue&type=script&lang=js"
import style0 from "./actorCard.vue?vue&type=style&index=0&id=49517c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49517c32",
  null
  
)

export default component.exports